<template>
    <div class="gradeApplicationAdultJCE">
      <div class="cont-box">
        <div class="title">
          <Title text="成绩申请" />
          <div>
            <el-form
              ref="search"
              :inline="true"
              :model="condition"
              :rules="searchRules"
              class="search-form"
              slot="search"
              label-width="80px"
            >
              <div style="display: flex; justify-content: space-between">
                <div>
                  <div>
                    <el-form-item prop="paper_plan_student_id">
                      <el-select
                        v-model="condition.paper_plan_student_id"
                        placeholder="请选择论文计划"
                        clearable
                        filterable
                        style="width: 300px;"
                      >
                        <el-option
                          v-for="item in thesisPlanList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="loadData">确认</el-button>
                    </el-form-item>
                  </div>
                </div>
                <div v-if="isShowDuplicate">
                  <div class="btn-box">
                    <div>
                      <el-form-item>
                        <el-button
                          type="primary"
                          class="link-btn"
                          @click="duplicateCheckClick"
                        >提交申请</el-button>
                      </el-form-item>
                    </div>
                  </div>
                  <div>
                    <el-form-item>
                      <span>成绩申请截止时间：{{end_apply_time}}</span>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div>
          <el-table
            :data="list"
            headerRowClassName="uni-primary-table-header"
            stripe
            border
          >
            <el-table-column prop="" align="center" label="流程标题">
              <template slot-scope="{row}">
                <span>{{ row.student_title }} + {{ row.process_title }} + {{ row.created_at }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="student_title" align="center" label="学生姓名"></el-table-column> -->
            <el-table-column prop="sign_img" align="center" label="手写签名">
              <template slot-scope="{row}">
                <img :src="row.sign_img" alt="" style="width: 200px;height: 40px;object-fit: contain;">
              </template>
            </el-table-column>
            <el-table-column prop="teacher_title" align="center" label="评分老师">
            </el-table-column>
            <el-table-column prop="final_score" align="center" label="设计资料最终得分">
            </el-table-column>
            <el-table-column prop="imgs_url" align="center" label="快递单凭证">
                <template slot-scope="{row}">
                    <div v-if="row.imgs_url">
                        <div v-for="(item, index) in JSON.parse(row.imgs_url)" :key="index">
                            <el-image
                                v-if="item.url"
                                :src="item.url"
                                :preview-src-list="[item.url]"
                                style="width: 50px;"
                                >
                            </el-image>
                        </div>
                    </div>
                </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 提交申请 -->
      <el-dialog
        class="duplicateCheck"
        title="提交申请"
        :visible.sync="isShowDuplicateCheck"
        width="40%"
        @close="duplicateCheckClose"
      >
        <div class="dialog" >
          <el-form
            ref="duplicateCheck"
            :model="duplicateCheckData"
            :rules="duplicateCheckRules"
            label-width="160px"
          >

            <el-form-item label="最终设计资料：" prop="files_url">
            <FalConUpload
                ref="uploadDuplicateCheck"
                listStyle='text'
                accept=".docx,.doc,.pdf,.txt"
                :limit="1"
                :isFile="true"
                :isAccept="true"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
            ></FalConUpload>
            <!-- <FalConUpload
                ref="uploadDuplicateCheck"
                :multiple="true"
                :limit="20"
                :isShowModal="false"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
            ></FalConUpload> -->
            <div>
                <span class="tips">说明：只能上传docx,doc,pdf,txt文件</span>
            </div>
            </el-form-item>
            <!-- <el-form-item label="最终设计资料:" prop="files_url2">
            <FalConUpload
                ref="uploadFile"
                listStyle='text'
                accept=".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                :limit='20'
                :multiple="true"
                :isFile="true"
                :isAccept="false"
                @handleRemove="handleRemoveFile"
                @handleChange="handleChangeFile"
            >
            </FalConUpload>
            <div class="tips">说明：可上传PDF文档，压缩文件或OFFICE文档</div>
            </el-form-item> -->
            <el-form-item label="手写签名:" prop="sign_img">
              <esignHandle
                ref="duplicateCheckEsignHandle"
                :selectSignImg.sync="duplicateCheckData.sign_img"
              ></esignHandle>
            </el-form-item>
            <el-form-item label="快递单凭证" prop="imgs_url">
              <FalConUpload
                ref="deliveryImg"
                :multiple="false"
                :isShowModal="false"
                @handleRemove="deliveryImgHandleRemove"
                @handleChange="deliveryImgHandleChange"
              ></FalConUpload>
              <div class="tips">
                <span  style="color: red;">
                  将毕业综合考核打印后的纸质资料按如下地址寄出。快递单照片或截图也上传。<br />
                  快递只能用顺丰快递<br />
                  快递地址：重庆市南岸区重庆医科大学继续教育学院<br />
                  收件人： 刘飞<br />
                  电话：62652913<br />
                </span>
              </div>
            </el-form-item>

          </el-form>
        </div>
        <div style="text-align: center">
          <el-button @click="isShowDuplicateCheck = false">取 消</el-button>
          <el-button type="primary" :loading="duplicateCheckLoading" @click="duplicateCheckSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>

  <script>
  import {
    adultStudentPpAll,
    studentPpsDuplicateUrl,

    getZkScore,
    zkScoreApply,
  } from "@/api/graduation";
  import FalConUpload from "@/components/uploadFile";
  import { putObject, uploadFiles, deleteObject } from "@/utils/upload";

  import esignHandle from '@/components/esignHandle';

  import {arrAttDel, deepClone} from '@/utils/func';

  import {downladUrl} from '@/utils/func';

  export default {
    name: "gradeApplicationAdultJCE",
    components: { FalConUpload, esignHandle },
    filters: {

    },
    data() {
      return {
        condition: {
          paper_plan_student_id: '',  //论文计划
        },
        searchRules: {
          paper_plan_student_id: [{ required: true, message: "请选择论文计划", trigger: "change" }],
        },
        thesisPlanList: [],  //论文计划列表

        isShowDuplicate: false,  //选择论文计划后出现的数据

        list:[],
        listTotal: -1,


        // 提交申请
        isShowDuplicateCheck: false,
        duplicateCheckData: {
          paper_plan_student_id: '',  //设计资料id
          files_url: '',  //查重文件
          files_url2: '',  //最终设计资料 文件
          sign_img: '',  //签名图片
          imgs_url: '',  //快递单图片
        },
        duplicateCheckRules: {
          files_url: [{ required: true, trigger: 'change', message: "请上传查重文件" }],
          files_url2: [{ required: true, trigger: 'change', message: "请上传最终设计资料文件" }],
          sign_img: [{ required: true, trigger: 'change', message: "请上传签名" }],
          imgs_url: [{ required: true, trigger: 'change', message: "* 请上传快递单照片" }],
        },

        duplicateCheckLoading: false,  //弹窗 提交申请 加载
        end_apply_time: '',  //答辩申请截止时间

      };
    },
    created() {
      // this.getListFn();
      this.getThesisPlanList();
    },
    methods: {
      // 点击进去检测
      enterDetection(row){
        let data = {
          paper_cnki_id: row.result.id,
        };
        studentPpsDuplicateUrl(data).then(res => {
          if(res.code == 200){
            window.open(res.result.redirect_url, '_blank');
          }
        });
      },
      // 弹窗 成绩申请 快递凭证
      deliveryImgHandleChange(data){
        this.duplicateCheckData.imgs_url = data.fileList;
      },
      //弹窗 成绩申请  快递凭证 删除
      deliveryImgHandleRemove(data){
        this.duplicateCheckData.imgs_url = '';
      },
      // 选择资料确认
      loadData(){
        this.$refs["search"].validate((valid) => {
          if (valid) {
            this.getListFn();
            let curItem = this.thesisPlanList.find(item => item.id === this.condition.paper_plan_student_id);
            this.end_apply_time = curItem.end_apply_time;
          }
        });
      },
      // 获取论文计划
      getThesisPlanList(){
        adultStudentPpAll().then(res => {
          this.thesisPlanList = res.result;
        });
      },
      // 弹窗 提交申请 提交
      duplicateCheckSubmit(){
        this.$refs["duplicateCheck"].validate(async (valid) => {
          if (valid) {
            this.duplicateCheckLoading = true;
            let queryData;

            let upload;
            let upload1;

            upload = new Promise((resolve, reject) => {
              uploadFiles(this.duplicateCheckData.files_url, (urls) => {
                resolve(urls);
              }, null, 'student', '', true);
            });

            upload1 = new Promise((resolve, reject) => {
              uploadFiles(this.duplicateCheckData.imgs_url, (urls) => {
                resolve(urls);
              }, null, 'student', '', true);
            });
            // files_url = await upload;
            // if(files_url){
            //     data.files_url = JSON.stringify(JSON.parse(files_url).map(item => {
            //     item.finalDesignFiles = JSON.parse(files_url);
            //     return item;
            //     }));
            // }
            Promise.all([upload, upload1]).then(urlList => {
              let data = deepClone(this.duplicateCheckData);
              let files_url = urlList[0];
              let imgs_url = urlList[1];
              queryData = {
                paper_plan_student_id: data.paper_plan_student_id,
                files_url: files_url,
                sign_img: data.sign_img,
                imgs_url: imgs_url,
              };
              zkScoreApply(queryData).then(res => {
                if (res.code == 200) {
                  this.$message.success('保存成功');
                  this.isShowDuplicateCheck = false;
                  // window.open(res.result.redirect_url, '_blank');
                  this.loadData();
                }
              }).finally(() => {
                this.duplicateCheckLoading = false;
              });
            });
          }
        })
      },
      // 弹窗 提交申请 查重文件 删除
      duplicateCheckHandleRemove(data){
        this.duplicateCheckData.files_url = data.fileList;
      },
      // 弹窗 提交申请 查重文件 多传
      duplicateCheckHandleChange(data){
        this.duplicateCheckData.files_url = data.fileList;
      },
      // 弹窗 提交申请 上传 最终设计资料文件
      handleChangeFile(data) {
        this.duplicateCheckData.files_url2 = data.fileList;
      },
      // 弹窗 提交申请 删除 最终设计资料文件
      handleRemoveFile(data) {
        this.duplicateCheckData.files_url2 = data.fileList;
      },
      // 弹窗 提交申请 关闭
      duplicateCheckClose(){
        this.duplicateCheckData = {
          defense_process_id: '',  //设计资料id
          files_url: '',  //查重文件
          files_url2: '',  //最终设计资料 文件
          sign_img: '',  //签名图片
          imgs_url: '',  //快递单图片
        };
        this.$refs['uploadDuplicateCheck'].reset();
        this.$refs['uploadFile'].reset();
        this.$refs['deliveryImg'].reset();
        this.$refs['duplicateCheckEsignHandle'].handleReset();  //签名这块清空
        this.$nextTick(() => {
          this.$refs["duplicateCheck"].clearValidate();
        });
      },
      // 点击 提交申请
      duplicateCheckClick(){
        this.duplicateCheckData.paper_plan_student_id = this.condition.paper_plan_student_id;
        this.isShowDuplicateCheck = true;
      },
      // 获取数据
      getListFn(){
        let data = {
          paper_plan_student_id: this.condition.paper_plan_student_id
        };
        getZkScore(data).then(res => {
          if(res.code == 200){
            this.list = res.result;
            this.isShowDuplicate = true;
          }
        });
      },
    },
    beforeDestroy() {

    },
  };
  </script>

  <style lang="scss">
  .gradeApplicationAdultJCE{
    .el-scrollbar{
      padding-bottom: 20px;
      .el-scrollbar__wrap{
        overflow-x: hidden;  // 隐藏自带的滚动条
      }
    }
  }
  </style>

  <style lang="scss" scoped>
  .gradeApplicationAdultJCE {
    min-height: $contentH;
    padding: $sideMargin;
    padding-bottom: 0;
    .cont-box{
      background: $white;
      min-height: inherit;
      padding: 0 20px 20px;
      .title{
        .btn-box{
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .tips{
      font-size: 12px;
      color: #999;
    }
    .duplicateCheckRes{
      .item{
        padding: 5px 0;
        .name{
          font-weight: bold;
        }
      }
    }
  }
  </style>
